import { Button, Classes, Dialog, Intent } from '@blueprintjs/core';
import styled from '@emotion/styled';
import { Instance } from 'mobx-state-tree';
import React from 'react';
import { TLCode } from '../../../common/enums';
import { Municipality } from '../../../store/models';
import CitySelection from '../../common/dropdownSelection/CitySelection';
import { TranslatedMessage } from '../../common/translation';

interface MunicipalitySelectionDialogProps {
  onMunicipalitySelected: (municipality: Instance<typeof Municipality>) => void;
  municipalities: Array<Instance<typeof Municipality>>;
  selectedMunicipality?: Instance<typeof Municipality>;
  isDialogOpen: boolean;
  confirmSelection: () => void;
  onClose: () => void;
  infoText?: string;
}

export const MunicipalitySelectionDialog = ({
  onMunicipalitySelected,
  municipalities,
  selectedMunicipality,
  isDialogOpen = false,
  confirmSelection,
  onClose,
  infoText,
}: MunicipalitySelectionDialogProps) => {
  return (
    <Dialog
      isOpen={isDialogOpen}
      onClose={onClose}
      title={<TranslatedMessage id={TLCode.MUNICIPALITY_Choose} />}
      style={{ width: '580px' }}
      enforceFocus={false}
      canOutsideClickClose={false}
    >
      <div className={Classes.DIALOG_BODY}>
        {infoText && (
          <>
            <span>{infoText}</span>
            &nbsp;
          </>
        )}
        <DivLine style={{ marginTop: '20px' }}>
          <DivColumn style={{ marginRight: '20px' }}>
            <TranslatedMessage id={TLCode.TRANSFER_PharmacyEntity} />
          </DivColumn>
          <DivColumn>
            <CitySelection
              cityList={municipalities}
              onChange={onMunicipalitySelected}
              selectedMunicipality={selectedMunicipality}
            />
          </DivColumn>
        </DivLine>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button
            intent={Intent.PRIMARY}
            disabled={selectedMunicipality === undefined}
            onClick={confirmSelection}
            text={<TranslatedMessage id={TLCode.GENERAL_Save} />}
          />
        </div>
      </div>
    </Dialog>
  );
};

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;
